import { FeatureToggle } from './types';
export function isToggleAvailable(currentUser) {
  return (// APP_ENV comes from Jenkins
    ['local', 'dev', 'rc'].includes(process.env.APP_ENV) || !!(currentUser && ['YWdlbnR6ZXJvQG5leHRpdmFjcm0uY29t', 'Zm9wd0BuZXp6YXJ0LmNvbQ==', 'cGF2bG8uc2luaWVsbmlrb3ZAbmV4dGl2YS5jb20='].includes(btoa(currentUser.emailAddress)))
  );
}
export function isToggleAvailableForFeature(currentUser, feature) {
  var isAvailable = isToggleAvailable(currentUser);

  if (!isAvailable) {
    console.error('Feature Toggle Unavailable');
  }

  return isAvailable && isFeatureExist(feature);
}
export function isFeatureExist(feature) {
  var isExist = Object.keys(FeatureToggle.Features).includes(feature);

  if (!isExist) {
    console.error("Available Features for toggling: " + JSON.stringify(Object.keys(FeatureToggle.Features)));
  }

  return isExist;
}
export function isFeatureEnabled(feature, features) {
  var f = features[feature];
  return !!(f && f.isEnabled);
}
export function filterEntitiesByAvailableFeatures(entities, features) {
  if (entities === void 0) {
    entities = [];
  }

  if (features === void 0) {
    features = {};
  }

  return entities.filter(function (e) {
    var FEATURE_MAP_BY_SLUG = FeatureToggle.FEATURE_MAP_BY_SLUG,
        RESTRICTED_FEATURE_SLUGS = FeatureToggle.RESTRICTED_FEATURE_SLUGS;

    if (e.slug && RESTRICTED_FEATURE_SLUGS.includes(e.slug)) {
      return isFeatureEnabled(FEATURE_MAP_BY_SLUG[e.slug], features);
    }

    return true;
  });
}